import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const overviewApi = createApi({
    reducerPath: 'overviewApi',
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    tagTypes: ['overview'],
    endpoints: build => ({
        getTotalStats: build.query({
            query: (data) => ({
                url: api.overview.getTotalStats(),
                method: 'GET',
                params: data
            }),
            providesTags: ['overview']
        }),
        getBookingsToday: build.query({
            query: (data) => ({
                url: api.overview.getBookingsToday(),
                method: 'GET',
                params: data
            }),
            providesTags: ['overview']
        }),
        getSalesByCategory: build.query({
            query: (data) => ({
                url: api.overview.getSalesByCategory(),
                method: 'GET',
                params: data
            }),
            providesTags: ['overview']
        }),
        getStatistics: build.query({
            query: (data) => ({
                url: api.overview.getStatistics(),
                method: 'GET',
                params: data
            }),
            providesTags: ['overview']
        }),
        getDailyRevenueByAdmin: build.query({
            query: (data) => ({
                url: api.overview.getDailyRevenueByAdmin(),
                method: 'GET',
                params: data
            }),
            providesTags: ['overview']
        })
    })
})

export const { useLazyGetTotalStatsQuery, useLazyGetBookingsTodayQuery, useLazyGetStatisticsQuery, useLazyGetDailyRevenueByAdminQuery } = overviewApi